export const MOVEMENT_TYPES = ["Outward", "Inward", "Return"];
export const PURPOSES = ["Sale", "Scrap Dispatch", "Stock Transfer", "Machine Movement", "Material Return", "Other"];
export const UNITS = ["MT", "KG", "PCS", "NOS", "SET"];

export const GP_STATUS_LABEL = {
  draft: "Draft",
  pending_verification: "Pending Verification",
  pending_authorization: "Pending Final Authorization",
  issued: "Issued",
  cancelled: "Cancelled",
};

export const GP_STATUS_COLOR = {
  draft: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  pending_verification: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
  pending_authorization: "bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300",
  issued: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  cancelled: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
};

export const VEHICLE_RE = /^[A-Z]{2}[0-9]{1,2}[A-Z]{0,3}[0-9]{1,4}$/;
export const NAVY = "#1e3a5f";
